/**
 * Ledger-transaction READ endpoints — request schemas + wire types.
 *
 * Unlike the write schemas in `ledgerTransactions.ts` (Pattern C RPCs behind
 * the backend), these serve plain RLS-scoped reads: the Hono handler runs the
 * query through the per-request user client, so org RLS does the
 * authorization (see docs/BACKEND_API.md → "Read endpoints"; template:
 * expensesReads.ts).
 *
 * The wire interfaces are shared by the API handlers (response construction)
 * and the web hooks (`useLedgerTransactionIndex`,
 * `useRelatedLedgerTransactions`) so the two sides cannot drift.
 */
import { z } from "zod";
// ---------------------------------------------------------------------------
// Query-param schemas
// ---------------------------------------------------------------------------
/**
 * Query params for GET /orgs/:orgId/journal-entries/index.
 *
 * Each id filters on the view's deduped linkage ARRAY (project_ids /
 * business_ids / person_ids — union of header FK + linked expense + AP
 * invoice + AR invoice), not the scalar header column: source documents are
 * the authoritative owners of entity linkage (the header columns are
 * populated inconsistently across write paths).
 *
 * `fundId` matches `fund_ids` — the deduped header fund ∪ every entry's
 * fund — so the fund detail page's Transactions tab shows every transaction
 * that touches the fund, matching its entry-level balances.
 */
export const ledgerTransactionIndexQuerySchema = z.object({
    projectId: z.string().uuid().optional(),
    businessId: z.string().uuid().optional(),
    personId: z.string().uuid().optional(),
    fundId: z.string().uuid().optional(),
});
//# sourceMappingURL=ledgerTransactionsReads.js.map